import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { PocketBaseProvider } from './contexts/PocketBaseContext';
import { AdminProvider } from './contexts/AdminContext';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import BookDetailPage from './pages/BookDetailPage';
import AdminPanel from './components/AdminPanel';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import OfflineIndicator from './components/OfflineIndicator';
import './App.css';

function App() {
  useEffect(() => {
    // Register service worker
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
          .then((registration) => {
            console.log('SW registered: ', registration);
          })
          .catch((registrationError) => {
            console.log('SW registration failed: ', registrationError);
          });
      });
    }

    // Set up theme color meta tag
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.content = '#6366f1';
    }

    // Set up apple-touch-icon
    const link = document.createElement('link');
    link.rel = 'apple-touch-icon';
    link.href = '/icon-192x192.png';
    document.head.appendChild(link);

    // Set up viewport meta tag for PWA
    const metaViewport = document.querySelector('meta[name="viewport"]');
    if (metaViewport) {
      metaViewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover';
    }
  }, []);

  return (
    <PocketBaseProvider>
      <AdminProvider>
        <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50">
          <Header />
          <main className="pt-20">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/book/:id" element={<BookDetailPage />} />
            </Routes>
          </main>
          <AdminPanel />
          <PWAInstallPrompt />
          <OfflineIndicator />
        </div>
      </AdminProvider>
    </PocketBaseProvider>
  );
}

export default App;